import { FC } from 'react'
import { useIsMobile } from 'hooks'

import CargoSizeControlDesktop from './CargoSizeControlDesktop'
import CargoSizeControlMobile from './CargoSizeControlMobile'
import { CargoSizeControlProps } from './types'

const CargoSizeControl: FC<CargoSizeControlProps<string>> = (props) => {
  const isMobile = useIsMobile()

  return isMobile ? <CargoSizeControlMobile {...props} /> : <CargoSizeControlDesktop {...props} />
}

export default CargoSizeControl
